module.exports = __webpack_public_path__ + "img/9.bac7820e.svg";